module.exports = __webpack_public_path__ + "static/media/privacypolicy_2025_01_15.13e697ca.htm";